import { ReduxRouter } from '@lagunovsky/redux-react-router'
import { GoogleOAuthProvider } from '@react-oauth/google'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import I18nProvider from './global/i18n/I18nProvider'

import './global/styles/styles.scss'

import { CaptureConsole } from '@sentry/integrations'
import * as Sentry from '@sentry/react'
import App from './app/App'
import { routerSelector } from './app/selectors'
import store, { history } from './app/store'
import { version } from './version'

const clientId = process.env.REACT_APP_GOOGLE_ID

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

const container = document.getElementById('root')
const root = createRoot(container)

console.log(version)

Sentry.init({
    dsn: 'https://bd46a858f5f44586b388e4a5ee17e44a@sentry.colosseum.eu/2',
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['AUTHORIZATION', 'LOGIN', 'CART', 'CARD', 'url', 'URL', 'VOUCHER', 'ACCOUNT', 'ACTIVE', 'TOKEN'],
    environment: ENVIRONMENT,
    integrations: [new Sentry.Replay(), new CaptureConsole({ levels: ['error'] })],
})

Sentry.configureScope((scope) => {
    const userEmail = localStorage.getItem('userEmail')
    scope.setTag('userEmail', userEmail)
    scope.setTag('path', window.location.pathname) // Set the path as a tag globally
    scope.setTag('version', version)
    const site = localStorage.getItem('site')
    scope.setTag('site', site)
})

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <I18nProvider>
                <GoogleOAuthProvider clientId={clientId}>
                    <ReduxRouter history={history} routerSelector={routerSelector}>
                        <App />
                    </ReduxRouter>
                </GoogleOAuthProvider>
            </I18nProvider>
        </Provider>
    </React.StrictMode>
)
